import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import {PDFDocument} from 'pdf-lib';

@Injectable({
  providedIn: 'root'
})
export class GeneratePdfService {

  constructor() { }
  async generatePdf(element: HTMLElement): Promise<Blob> {
    const canvas = await html2canvas(element);

    const imgData = canvas.toDataURL('image/png');
    // console.log('in pdf gen serv');
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([595.28, 841.89]);

    const imgBytes = await fetch(imgData).then((response) => response.arrayBuffer());
    const pngImage = await pdfDoc.embedPng(imgBytes);

    const pdfWidth = page.getWidth();
    const pdfHeight = page.getHeight();
    const scaledWidth = pdfWidth - 10;
    const scaledHeight = (imgHeight * scaledWidth) / imgWidth;
    const y = Math.max(pdfHeight - scaledHeight - 10, 0);

    page.drawImage(pngImage, {
      x: 10,
      y,
      width: scaledWidth,
      height: scaledHeight
    });

    const pdfBytes = await pdfDoc.save();
    return new Blob([pdfBytes], {type: 'application/pdf'});
  }

  // async generatePdf(element: HTMLElement, filename: string): Promise<void> {
  //   const canvas = await html2canvas(element);
  //   const contentDataURL = canvas.toDataURL('image/png');
  //   const pdf = new jspdf.jsPDF('p', 'mm', 'a4');
  //   const imgWidth = 210; // A4 width in mm
  //   const imgHeight = canvas.height * imgWidth / canvas.width;
  //   pdf.addImage(contentDataURL, 'PNG', 0, 0, imgWidth, imgHeight);
  //   pdf.save(filename);
  // }
}
